// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-roles-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 16px;
}

.sa-role-card {
    background: var(--sa-card);
    border-radius: 16px;
    padding: 22px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s;
}

.sa-role-card:hover {
    transform: translateY(-2px);
    background: var(--sa-card-hover);
}

.sa-role-card.selected {
    border: 2px solid var(--sa-role-color);
}

.sa-role-icon-box {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
}

.sa-access-bar {
    display: flex;
    height: 8px;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 10px;
}

.sa-user-pill {
    display: flex;
    align-items: center;
    gap: 6px;
    background: var(--sa-bg);
    border-radius: 8px;
    padding: 5px 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SuperAdmin/SARoles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":[".sa-roles-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n    gap: 16px;\n}\n\n.sa-role-card {\n    background: var(--sa-card);\n    border-radius: 16px;\n    padding: 22px;\n    cursor: pointer;\n    border: 2px solid transparent;\n    transition: all 0.2s;\n}\n\n.sa-role-card:hover {\n    transform: translateY(-2px);\n    background: var(--sa-card-hover);\n}\n\n.sa-role-card.selected {\n    border: 2px solid var(--sa-role-color);\n}\n\n.sa-role-icon-box {\n    width: 48px;\n    height: 48px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 22px;\n}\n\n.sa-access-bar {\n    display: flex;\n    height: 8px;\n    border-radius: 4px;\n    overflow: hidden;\n    margin-bottom: 10px;\n}\n\n.sa-user-pill {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: var(--sa-bg);\n    border-radius: 8px;\n    padding: 5px 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
